module.exports = __webpack_public_path__ + "static/media/google-maps.28aac66d.png";